module.exports = __webpack_public_path__ + "static/media/7@3x.4608d5bc.png";